import { Box } from '@primer/react';
import LegalGroupPage from './group';
import LegalDocumentPage from './document';
import LegalViewPage from './view';
import Text from '../../components/ui/text';

const LegalLayoutPage = () => {
    return (
        <Box sx={{
            display: "flex"
        }}>
            <Box sx={{ flex: 1 }}>
                <Box><LegalGroupPage /></Box>
                <Box>
                    <LegalDocumentPage />
                </Box>
            </Box>
            <Box sx={{
                backgroundColor: "#F0EBF8",
                p: 3,
                height: window.innerHeight - 90,
                overflowY: "auto",
                width: "450px",
                pr: 4
            }}>
                <Text text="View as Parents" sx={{
                    fontSize: "24px",
                    fontWeight: 600,
                    mt: -2
                }} />
                <Box sx={{ mt: 3 }}>
                    <LegalViewPage />
                </Box>
            </Box>
        </Box>
    );
};

export default LegalLayoutPage;